/**
 * The instruments. A closed set, three on screen at once.
 *
 * THREE, AND THAT IS ALL OF THEM NOW. `files` and `transcript` were both
 * here and both went: attachments-in-flight are visible on the composer
 * and droppable anywhere on the screen, so a panel for them was a third
 * place to look at the same thing, and the CONVERSATION is not an
 * instrument. It is the thing itself, so the chevron opens it rather than
 * it queueing behind a button alongside a file browser.
 *
 * TWO IS WORKING, THREE IS A CHOICE, FOUR IS A DASHBOARD. A dashboard is a
 * surface nobody reads, which is the failure the reporting standard was
 * written to kill, so the cap is in code rather than in anybody's
 * judgement. Opening a fourth closes the oldest AGENT-opened panel and
 * never one of yours.
 */

export type PanelId = 'context' | 'pages' | 'workspace'

export const PANEL_LABEL: Record<PanelId, string> = {
  context: 'What I can see',
  pages: 'Here you can',
  workspace: 'Workspace files',
}

/** Three. See the note above. */
export const MAX_PANELS = 3

export interface OpenPanel {
  id: PanelId
  /**
   * Who opened it.
   *
   * A panel you opened stays until you close it. One the AGENT opened can
   * be closed to make room. Without that split, either the agent tidies
   * away something you were reading, or the screen silts up with panels
   * nobody remembers asking for.
   */
  by: 'you' | 'agent'
  /** For deciding which agent-opened panel is oldest. */
  at: number
}
